module.exports = __webpack_public_path__ + "img/cornerRightBottom.b74e3e55.svg";